<nz-form-item>
    <nz-form-label [nzFor]="label" [nzRequired]="required">{{ label }}</nz-form-label>
    <nz-form-control  style="width: 100%;" >
        <ng-content></ng-content>
    </nz-form-control>
</nz-form-item>

  